export const DRAG_SUMMARY_PARTS = [
  'container',
  'draggedItemDescription',
] as const;
